/** @jsx React.DOM */
'use strict';

var React = require('react'),
    ItemTypes = require('./ItemTypes'),
    $__0=    React,PropTypes=$__0.PropTypes,
    $__1=    require('react-dnd'),DragDropMixin=$__1.DragDropMixin;

var Item = React.createClass({displayName: 'Item',
  mixins: [DragDropMixin],

  propTypes: {
    type: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  },

  getInitialState:function() {
    return {
      hasDropped: false
    };
  },

  configureDragDrop:function(registerType) {
    registerType(this.props.type, {
      dragSource: {
        beginDrag:function() {
          return {
            item: {
              name: this.props.name,
            }
          };
        },

        endDrag:function(didDrop) {
          if (didDrop) {
            this.setState({
              hasDropped: true
            });
          }
        }
      }
    });
  },

  render:function() {
    var $__0=    this.props,type=$__0.type,
        $__1=    this.state,hasDropped=$__1.hasDropped,
        $__2=    this.getDragState(type),isDragging=$__2.isDragging;

    return (
      React.createElement("div", React.__spread({},  this.dragSourceFor(type), 
           {style: {
             border: '1px dashed gray',
             backgroundColor: 'white',
             padding: '0.5rem',
             margin: '0.5rem',
             opacity: isDragging ? 0.4 : 1,
             maxWidth: 80,
             float: 'left'
           }}), 

        hasDropped ?
          React.createElement("s", null, this.props.name) :
          this.props.name
        

      )
    );
  }
});

module.exports = Item;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-interesting/Item.js
 ** module id = 141
 ** module chunks = 0
 **/